import {FieldConfig, FieldDataTypes, nString, uString} from "@hidat/huijs-common";

/**
 * Branded Resources = Stolen from Splixer
 * We have several entities that have very similar data related to 'branding' information for the resource.
 * This would be imagery, naming, descriptions.
 * This is an attempt to normalize this data so we can have a single set of services and interfaces to deal with it.
 */
export interface ExtendedBrandingInterface {
  colorScheme?: 'dark' | 'light' | undefined | null;
  backgroundColor?: nString;

  backgroundImageUrl?: nString;   // Large background image
  bannerImageUrl?: nString;   // Long horizontal banner image
  avatarImageUrl?: nString;   // Squarish avatar/button image
}

export const ExtendedBrandingFields = [
  new FieldConfig('colorScheme'),
  new FieldConfig('backgroundColor'),
  new FieldConfig('backgroundImageUrl'),
  new FieldConfig('bannerImageUrl'),
  new FieldConfig('avatarImageUrl')
]

export const BrandedResourceFields = {
  name: new FieldConfig('name').setRequired(true),
  tagLine: new FieldConfig('tagLine'),
  description: new FieldConfig('description'),
  imageUrl: new FieldConfig('imageUrl'),
  branding: new FieldConfig('branding', FieldDataTypes.HASH)
}
export interface BrandedResource {
  name: uString;
  tagLine: nString;
  description: nString;
  imageUrl: nString;
  branding: ExtendedBrandingInterface | undefined;
}
